import { SvgIcon, SxProps } from "@mui/material";
import ReactionLoveSvg from "jsx:../../../Images/Icons/Custom/reactionLove.svg";

export function ReactionLoveIcon(props: SxProps) {
    return <SvgIcon component={ReactionLoveSvg} inheritViewBox sx={props} />;
}
